import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { IApiResponse, ITecnico } from 'src/app/interfaces';
import { OSService, TecnicoService } from 'src/app/services';

@Component({
  selector: 'app-tecnico',
  templateUrl: './tecnico.component.html',
  styleUrls: ['./tecnico.component.scss']
})
export class TecnicoComponent implements OnInit, OnDestroy {
  subscriptions$ = new Subscription();
  tecnicos: ITecnico[];
  encaminhaTecnicoForm: FormGroup;
  labelBotao: string = 'Encaminhar';

  constructor(
    private fb: FormBuilder,
    private tecnicoService: TecnicoService,
    private osService: OSService
  ) {}
 

  ngOnInit() {
    this.getTecnicos();
    this.encaminhaTecnicoForm = this.fb.group({
      tecnico: ['']
    });
  }

  getTecnicos() {
    this.subscriptions$.add(
      this.tecnicoService.getTecnico().subscribe({
        next: (response) => {
          this.tecnicos = response.data;
        }
      })
    );
  }

  doEncaminhar() {
    const tecnicoOs = {
      codigoOS: '000031',
      codTec: this.encaminhaTecnicoForm.getRawValue().tecnico
    };

    this.subscriptions$.add(
      this.osService.postOSTecnico(tecnicoOs).subscribe({
        complete: () => {}
      })
    );
  }

  isButtonEnabled(): boolean {
    return !!this.encaminhaTecnicoForm.getRawValue().tecnico;
  }

  ngOnDestroy(): void {
    this.subscriptions$.unsubscribe();
  }
}
